module.exports = __webpack_public_path__ + "static/media/EXE.6ab4e54d.svg";